(() => {
  const init = (scope) => scope.querySelectorAll('[data-rw-direct]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-rw-order]');
    const money = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'});
    if (form) {
      const quantity = form.querySelector('[data-rw-quantity]');
      const buy = form.querySelector('[data-rw-buy]');
      const add = form.querySelector('[data-rw-add]');
      const note = form.querySelector('[data-rw-stock-note]');
      const error = form.querySelector('[data-rw-error]');
      const status = form.querySelector('[data-rw-available-note]');
      const update = () => {
        const option = form.querySelector('[data-rw-option]:checked');
        if (!option) return;
        const limited = option.dataset.limited === 'true';
        const remaining = Number(option.dataset.remaining);
        const available = option.dataset.available === 'true' && (!limited || remaining > 0);
        quantity.max = '5';
        quantity.readOnly = false;
        quantity.disabled = !available;
        const amount = Number(quantity.value);
        const valid = Number.isInteger(amount) && amount >= 1 && amount <= Number(quantity.max) && (!limited || amount <= remaining);
        buy.disabled = !available || !valid;
        add.disabled = buy.disabled;
        buy.textContent = available ? root.dataset.buyLabel : root.dataset.unavailableLabel;
        note.hidden = available;
        if (status) status.hidden = !available;
        form.querySelector('[data-rw-summary-name]').textContent = option.dataset.selection;
        if (Number.isSafeInteger(amount) && amount > 0) {
          const cents = Number(option.dataset.price) * amount;
          form.querySelector('[data-rw-summary-net]').textContent = money.format(cents / 100);
          form.querySelector('[data-rw-summary-gross]').textContent = money.format(Math.round(cents * 1.19) / 100);
        }
        root.querySelector('[data-rw-ask]').href = option.dataset.ask;
        error.hidden = true;
      };
      form.querySelectorAll('[data-rw-option]').forEach((option) => option.addEventListener('change', () => {quantity.value = '1'; update();}));
      quantity.addEventListener('input', update);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        update();
        if (buy.disabled || !form.reportValidity()) return;
        buy.disabled = true;
        buy.textContent = root.dataset.loadingLabel;
        try {
          const cartResponse = await fetch(`${root.dataset.cartUrl}.js`, {headers: {'Accept': 'application/json'}});
          if (!cartResponse.ok) throw new Error(root.dataset.errorLabel);
          const currentCart = await cartResponse.json();
          const option = form.querySelector('[data-rw-option]:checked');
          const units = {'59203385393487':1,'59203384115535':1,'58760817312079':1,'58900606517583':1,'58761265480015':3,'58761296576847':5};
          const palletCount = currentCart.items.reduce((sum,i) => sum + (units[String(i.variant_id)] || 0) * i.quantity, 0);
          if (currentCart.items.some(i => !units[String(i.variant_id)])) throw new Error(root.dataset.cartLimitError);
          if (palletCount + Number(quantity.value) > 5) throw new Error(root.dataset.qtyError);
          const present = currentCart.items.filter(i => String(i.variant_id) === option.value).reduce((sum,i) => sum + i.quantity,0);
          if (present + Number(quantity.value) > Number(quantity.max)) throw new Error(root.dataset.qtyError);
          add.disabled = true;
          const response = await fetch(root.dataset.addUrl, {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : root.dataset.errorLabel);
          window.location.assign(event.submitter === add ? root.dataset.cartUrl : root.dataset.checkoutUrl);
        } catch (failure) {
          update();
          error.textContent = failure.message || root.dataset.errorLabel;
          error.hidden = false;
        }
      });
      update();
    }
    const main = root.querySelector('[data-rw-featured]');
    const link = root.querySelector('[data-rw-photo-link]');
    const thumbs = [...root.querySelectorAll('[data-rw-thumbnail]')];
    const dialog = root.querySelector('[data-rw-lightbox]');
    let index = 0;
    const select = (next) => {
      index = (next + thumbs.length) % thumbs.length;
      const thumb = thumbs[index];
      if (!thumb || !main || !link) return;
      main.removeAttribute('srcset');
      main.src = thumb.dataset.url;
      main.alt = thumb.dataset.alt;
      link.href = thumb.href;
      thumbs.forEach((item, position) => item.setAttribute('aria-current', String(position === index)));
      dialog.querySelector('[data-rw-large]').src = thumb.href;
      dialog.querySelector('[data-rw-large]').alt = thumb.dataset.alt;
      dialog.querySelector('[data-rw-counter]').textContent = `${index + 1} / ${thumbs.length}`;
    };
    thumbs.forEach((thumb, position) => thumb.addEventListener('click', (event) => {event.preventDefault(); select(position);}));
    if (link && dialog && thumbs.length) {
      link.addEventListener('click', (event) => {if (!dialog.showModal) return; event.preventDefault(); select(index); dialog.showModal();});
      dialog.querySelector('[data-rw-close]').addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-rw-next]').addEventListener('click', () => select(index + 1));
      dialog.querySelector('[data-rw-previous]').addEventListener('click', () => select(index - 1));
      dialog.addEventListener('click', (event) => {if (event.target === dialog) dialog.close();});
      dialog.addEventListener('keydown', (event) => {if (event.key === 'ArrowRight') {event.preventDefault();select(index + 1);} if (event.key === 'ArrowLeft') {event.preventDefault();select(index - 1);}});
    }
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
